// PrivateRoute.jsx
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export default function PrivateRoute() {
  const { user, loadingApp } = useContext(AuthContext);

  // Enquanto o contexto ainda estiver carregando (verificando token), exibe um carregando:
  if (loadingApp) {
    return <div>Carregando...</div>;
  }

  // Se não houver usuário autenticado, redireciona para a tela de login ("/")
  return user ? <Outlet /> : <Navigate to="/" />;
}
